import { adapterClient, handleApiError } from './client';
import { entityIdSchema, projectViewSchema } from '@/types/current-project';

export function canonicalProjectId(id: string): string {
  entityIdSchema.parse(id);
  return '0x' + id.replace(/^0x/, '').toLowerCase();
}
function invalidResponse(): never {
  throw new Error(
    'The server returned unsupported project data. Please retry or report the response.'
  );
}
export async function listProjectViews(signal?: AbortSignal) {
  try {
    const { data } = await adapterClient.get<unknown>('/projects', { signal });
    const result = projectViewSchema.array().safeParse(data);
    if (!result.success) return invalidResponse();
    return result.data.sort(
      (a, b) => (b.createdAt ?? -1) - (a.createdAt ?? -1)
    );
  } catch (error) {
    handleApiError(error, 'list projects');
  }
}
export async function getProjectView(id: string, signal?: AbortSignal) {
  if (!entityIdSchema.safeParse(id).success)
    throw new Error('Invalid project identifier.');
  const projectId = canonicalProjectId(id);
  try {
    const { data } = await adapterClient.get<unknown>(
      '/projects/' + projectId,
      { signal }
    );
    const result = projectViewSchema.safeParse(data);
    if (!result.success || result.data.projectId !== projectId)
      return invalidResponse();
    return result.data;
  } catch (error) {
    handleApiError(error, 'read project');
  }
}
